import { useGetConfig } from "@onefront/forrestjs-react-root";
import { AccessDenied, TSLogo } from "../../images";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Button from "@vapor/react-material/Button";
import Stack from "@vapor/react-material/Stack";
import { useTranslation } from "../../service-i18n";
import { useTargetUrl } from "../../service-axios";

export const DefaultErrorView = ({ error }) => {
  const { t } = useTranslation("react-sdk");
  const urn = useGetConfig("one.appId");
  const { url } = useTargetUrl(urn, []);
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ p: "32px", gap: "32px", flex: "1" }}
    >
      <TSLogo />
      <AccessDenied />
      <ExtendedTypography
        variant="display"
        gutterBottom
        component="div"
        color="primary.textTitleColor"
      >
        {t("access_denied")}
      </ExtendedTypography>
      <ExtendedTypography variant="titleMedium" color="primary.textTitleColor">
        {t("contact_admin")}
      </ExtendedTypography>
      <Button
        variant="contained"
        onClick={() => {
          window.location.href = url;
        }}
      >
        {t("back_to_home")}
      </Button>
    </Stack>
  );
};
